import {
	IChangeUserPasswordRequestData,
	ICreateUserRequestData,
	IEditUserRequestData,
	IGetActiveSessionsRequestData,
	IGetActiveSessionsResponse,
	IGetUserActivityLogsRequestData,
	IGetUserActivityLogsResponse,
	IGetUsersListRequestData,
	IGetUsersListResponse,
	IGetUsersListResponseData
} from "../../types";
import { getAPIHeaderOptions, transformErrorResponse } from "../../utils/apiUtils";
import { queries } from "./queries.reducer";

const userManagement = queries.injectEndpoints({
	endpoints: (builder) => ({
		// GET USERS LIST
		getUsersList: builder.query<IGetUsersListResponse, IGetUsersListRequestData>({
			query: (requestData) => ({
				url: "/auth/rbac/users/",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// CREATE USER
		createUser: builder.mutation<IGetUsersListResponseData, ICreateUserRequestData>({
			query: (requestData) => ({
				url: "/auth/rbac/users/",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// EDIT USER
		editUser: builder.mutation<IGetUsersListResponseData, IEditUserRequestData>({
			query: (requestData) => ({
				url: `/auth/rbac/users/${requestData.id}/`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData.data
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// GET ACTIVE SESSIONS
		getActiveSessions: builder.query<IGetActiveSessionsResponse, IGetActiveSessionsRequestData>({
			query: (requestData) => ({
				url: "/auth/rbac/users/get_active_users/",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// FORCE LOGOUT USER
		forceLogoutUser: builder.mutation<void, number>({
			query: (userId) => ({
				url: `/auth/rbac/users/delete_user_tokens/`,
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: { user_id: userId }
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// GET USER ACTIVITY LOGS
		getUserActivityLogs: builder.query<IGetUserActivityLogsResponse, IGetUserActivityLogsRequestData>({
			query: (requestData) => ({
				url: "/coreconfig/audit-logs",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// CHANGE USER PASSWORD
		changeUserPassword: builder.mutation<void, IChangeUserPasswordRequestData>({
			query: (requestData) => ({
				url: `/auth/rbac/users/${requestData.id}/change_password/`,
				headers: { ...getAPIHeaderOptions(true) },
				method: "PATCH",
				body: requestData.data
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// DELETE USER
		deleteUser: builder.mutation<unknown, number>({
			query: (user_id) => ({
				url: `/auth/rbac/users/${user_id}/`,
				headers: getAPIHeaderOptions(true),
				method: "DELETE"
			}),
			transformErrorResponse
		})
	})
});

export const {
	// GET USERS LIST
	useGetUsersListQuery,
	// CREATE USER
	useCreateUserMutation,
	// EDIT USER
	useEditUserMutation,
	// GET ACTIVE SESSIONS
	useGetActiveSessionsQuery,
	// FORCE LOGOUT USER
	useForceLogoutUserMutation,
	// GET USER ACTIVITY LOGS
	useGetUserActivityLogsQuery,
	// CHANGE USER PASSWORD
	useChangeUserPasswordMutation,
	// DELETE USER
	useDeleteUserMutation
} = userManagement;
